import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {

    transform(seconds: number): string {
        if (seconds == null) {
            return '';
        }

        // let seconds = Math.floor(milliseconds / 1000);
        let minutes = Math.floor(seconds / 60);
        seconds = Math.floor(seconds % 60);
        const hours = Math.floor(minutes / 60);
        minutes = minutes % 60;

        const hoursStr = (hours < 10) ? '0' + String(hours) : String(hours);
        const minutesStr = (minutes < 10) ? '0' + String(minutes) : String(minutes);
        const secondsStr = (seconds < 10) ? '0' + String(seconds) : String(seconds);
        return hoursStr + ':' + minutesStr + ':' + secondsStr;
    }

}
